import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'lib-loading-icon',
    imports: [CommonModule],
    templateUrl: './loading-icon.component.html',
    styleUrl: './loading-icon.component.scss'
})
export class LibLoadingIconComponent {}
